/** Uniform vertical rhythm for homepage section blocks. */
export const HOME_SECTION_PADDING_CLASS = 'py-10 sm:py-12 md:py-14 lg:py-16';
